/* eslint-disable react-hooks/exhaustive-deps */
import { yupResolver } from "@hookform/resolvers/yup"
import { APPROVAL } from "pages/Sales/Register/utils/vars"
import { useEffect, useMemo } from "react"
import { FormProvider, useForm } from "react-hook-form"
import toast from "react-hot-toast"
import { useApi, useHandleAuth } from "utils"
import { today } from "utils/functions"
import { FormSection } from "./components"
import { formTransferItemsSchema, FormTransferItemsType } from "./types"
import { submitMap } from "./utils/functions"
import { useLocation } from "react-router-dom"

export default function TransferItems() {
  const api = useApi()
  const { userTokenData } = useHandleAuth()
  const userToken = userTokenData()
  const location = useLocation();

  const emptyValues: FormTransferItemsType = {
    trx_code: "",
    location_from_id: NaN,
    location_to_id: NaN,
    employee_id: userToken?.user_id ?? NaN,
    transaction_date: today(),
    memo: "Transfer Item transaction",
    transfer_detail: [],
    approval_status: APPROVAL.PENDING,
    approval_status_text: "PENDING",
    approved_by: "",
    approved_by_name: "",
    location_from_name: "",
    location_to_name: "",
    imgPath: []
  }

  const defaultValues: FormTransferItemsType = useMemo(
    () => ({
      trx_code: "",
      location_from_id: location?.state?.sourceLocation ?? NaN,
      location_to_id: location?.state?.location ?? NaN,
      employee_id: userToken?.user_id ?? NaN,
      transaction_date: today(), 
      memo: "Transfer Item transaction",
      transfer_detail: location?.state?.data
        ? location?.state?.data?.map((val: any) => ({
          ...val,
          soh: val?.source_soh,
          soh_destination: val?.destination_soh,
          quantity_transfer: val?.ship_qty,
          location_warehouse_id: Number(val?.location_warehouse_id) || NaN,
          warehouse_name: val?.warehouse_name ?? ""
        }))
        : [],
      approval_status: APPROVAL.PENDING,
      approval_status_text: "PENDING",
      approved_by: "",
      approved_by_name: "",
      location_from_name: "",
      location_to_name: "",
      imgPath: []
    }),
    []
  )

  const onSubmit = async (value: any) => {
    return await submitPromise(value)
  }

  const methods = useForm<any>({
    defaultValues,
    resolver: yupResolver(formTransferItemsSchema)
  })

  const submitPromise = async (value: any) => {
    return await toast
      .promise(api.post("/transfer/add", submitMap(value)), {
        loading: "Loading...",
        success: (res) => res.data.message,
        error: (err) =>
          err.response.data.detail?.message ?? err.response.data.message
      })
      .then(() => {
        methods.reset(emptyValues)
      })
      .catch((err) => {
        throw new Error(err)
      })
  }

  useEffect(() => methods.reset(defaultValues), [defaultValues])

  return (
    <FormProvider {...methods}>
      <FormSection onSubmit={methods.handleSubmit(onSubmit)} />
    </FormProvider>
  )
}
